/* =============================================================================
 * APP BRANDING — this file is the single source of truth for this app's identity.
 *
 * APP_NAME / APP_DESCRIPTION / BRAND_COLOR below drive the browser-tab <title>,
 * the social + PWA meta tags, the generated logo/icons, and the package.json
 * name + description — all are derived FROM this file at scaffold time. To rename
 * or rebrand the app, edit the values here; do NOT hardcode the product name
 * anywhere else, because these places are regenerated and your edit would be lost:
 *   • app/index.html <title> + og/twitter/apple title  ← APP_NAME
 *     ...description meta + theme-color meta            ← APP_DESCRIPTION / BRAND_COLOR
 *     (synced at scaffold time on BOTH the flagship-template and custom paths)
 *   • root/app/api package.json name + description      ← synced from here + project name
 *   • app/src/locales/<lang>/ui.ts strings              → prefer t('app.name', …)
 *     over a literal product name so a rename here flows through every locale
 * After changing BRAND_COLOR or replacing public/logo.svg, run:
 *   npm run generate-icons   (rebuilds favicon, PWA icons, splash, OG, + HTML meta)
 * ============================================================================= */
/**
 * Centralized branding configuration.
 * Edit this file to customize your app's brand identity.
 *
 * To replace the logo:
 *   1. Replace public/logo.svg with your custom SVG (32x32 viewBox recommended)
 *   2. Run: npm run generate-icons
 *   This regenerates favicon, PWA icons, splash screens, OG image, and
 *   HTML meta tags (description, theme-color, OG/Twitter tags) — 12 files total.
 */

/** Display name (Header, PWA manifest, OG tags). */
export const APP_NAME = 'Molecule.dev Status'

/** Tagline. */
export const APP_TAGLINE = 'Live status of Molecule.dev services'

/** Logo size in pixels (Header, auth pages). */
export const LOGO_SIZE = 30

/** "About" link URL in the Footer. */
export const WEBSITE_URL = 'https://www.molecule.dev'

/** App description (PWA manifest, OG tags). */
export const APP_DESCRIPTION =
  'Live status and incident history for Molecule.dev — API, database, sandboxes, realtime, and queue.'

/** Primary brand color (PWA manifest, meta theme-color). Matches theme.css --color-primary. */
export const BRAND_COLOR = '#4070e0'
